import React, { useState, useContext, useEffect, useRef } from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";
import TextInput from "common/TextInput";

const doesNothing = () => {};

const CreateCommunity = ({
  others = [],
  doSave = doesNothing,
  doValidate = doesNothing,
}) => {
  const actions = useContext(ActionsContext);
  const [communityCreation, setCommunityCreation] = useState(false);
  const showCommunityCreation = () => setCommunityCreation(true);
  const hideCommunityCreation = () => setCommunityCreation(false);

  useEffect(() => {
    actions.recv("new-community", () => showCommunityCreation());
  }, []);

  return (
    <React.Fragment>
      {communityCreation === true ? (
        <CreateCommunityModal
          active={communityCreation}
          others={others}
          doSave={doSave}
          doValidate={doValidate}
          onClose={hideCommunityCreation}
        />
      ) : null}
    </React.Fragment>
  );
};

const getFormData = (form) => {
  const data = new FormData(form);
  return Object.fromEntries(data.entries());
};

const CreateCommunityModal = ({
  doValidate = doesNothing,
  doSave = doesNothing,
  onClose = doesNothing,
}) => {
  const form = useRef(null);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(true);
  const doClose = () => setOpen(false);

  if (open === false) {
    return null;
  }

  const handleChange = () => {
    try {
      const currently = getFormData(form.current);
      doValidate(currently);
      setError(null);
    } catch (error) {
      setError(error);
    }
  };

  const doApply = () => {
    try {
      const currently = getFormData(form.current);
      doSave(currently);
      doClose();
    } catch (error) {
      setError(error);
    }
  };

  return (
    <Modal
      title="Create Community"
      superIcon="add_circle"
      large={false}
      content={() => (
        <form ref={form}>
          <AskCommunityName onChange={handleChange} />
          <AskNMS onChange={handleChange} />
        </form>
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={error !== null}
      closeLabel="CANCEL"
      onClose={onClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};

const AskCommunityName = ({ name, onChange }) => (
  <>
    <TextInput
      type="text"
      name="name"
      label="Community:"
      className="input-control"
      defaultValue={name}
      onChange={onChange}
      icon={"assignment_ind"}
    />
  </>
);

const AskNMS = ({ nms, onChange }) => (
  <>
    <TextInput
      type="text"
      name="nms"
      label="NMS IP Address:"
      className="input-control"
      defaultValue={nms}
      onChange={onChange}
      iconOption={true}
      icon={"cloud_queue"}
      placeholder={"Ex: 10.1.0.1 or 2001:db8:80::"}
    />
  </>
);

export default CreateCommunity;
